export const PIC_FORM = {
  ROUND: 0,
  SQUARED: 1
};